<template>

  <div class="content">

    <el-form ref="form" :model="item" :rules="validation" label-width="220px">
      <el-form-item label="Title" prop="title">
        <el-input v-model="item.title" id="title"/>
      </el-form-item>

      <el-form-item label="Emails" prop="emails">
        <el-select style="width: 100%" v-model="item.emails" id="emails" multiple filterable allow-create
                   placeholder="Enter emails"/>
      </el-form-item>

      <el-form-item label="Icon" prop="options.icon">
        <el-select v-model="item.options.icon" placeholder="Select an icon">
          <el-option
            v-for="item in icons"
            :key="item"
            :label="item"
            :value="item">
            <span :class="'fa fa-' + item"></span> {{ item }}
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Confirmation message" prop="options.successMessage">
        <el-input v-model="item.options.successMessage" id="successMessage"/>
      </el-form-item>

      <el-form-item label="Target URL after shipment" prop="options.redirectToUrl">
        <el-input v-model="item.options.redirectToUrl" id="redirectToUrl"/>
      </el-form-item>

      <el-form-item label="Send button" prop="options.buttonCaption">
        <el-input v-model="item.options.buttonCaption" id="buttonCaption"/>
      </el-form-item>

      <el-form-item label="Next button" prop="options.nextButtonCaption">
        <el-input v-model="item.options.nextButtonCaption" id="nextButtonCaption"/>
      </el-form-item>

      <el-form-item label="Back button" prop="options.backButtonCaption">
        <el-input v-model="item.options.backButtonCaption" id="backButtonCaption"/>
      </el-form-item>

      <el-form-item label="Required * error" prop="options.requiredFieldCaption">
        <el-input v-model="item.options.requiredFieldCaption" id="requiredFieldCaption"/>
      </el-form-item>

      <el-form-item label="Field icon width" prop="options.iconWidth">
        <el-input-number v-model="item.options.iconWidth" id="iconWidth" :min="32" :max="300"></el-input-number>
      </el-form-item>

      <el-form-item label=" " prop="options.withSubscription">
        <el-checkbox v-model="item.options.withSubscription" id="withSubscription">Enable subscription</el-checkbox>
      </el-form-item>

      <el-form-item label="Checkbox title" prop="options.subscriptionTitle" v-if="item.options.withSubscription">
        <el-input v-model="item.options.subscriptionTitle" id="subscriptionTitle"/>
      </el-form-item>
      <el-form-item label="Checkbox text" prop="options.subscriptionCheckbox" v-if="item.options.withSubscription">
        <el-input v-model="item.options.subscriptionCheckbox" id="subscriptionCheckbox"/>
      </el-form-item>
      <el-form-item label="Confirmation email subject" prop="options.subscriptionConfirmationEmailSubject" v-if="item.options.withSubscription">
        <el-input v-model="item.options.subscriptionConfirmationEmailSubject" id="subscriptionConfirmationEmailSubject"/>
      </el-form-item>
      <el-form-item label="Confirmation email text" prop="options.subscriptionConfirmationEmail" v-if="item.options.withSubscription">
        <el-input type="textarea" v-model="item.options.subscriptionConfirmationEmail" id="subscriptionConfirmationEmail"/>
      </el-form-item>
      <el-form-item label="Success page URL" prop="options.subscriptionRedirect" v-if="item.options.withSubscription">
        <el-input v-model="item.options.subscriptionRedirect" id="subscriptionRedirect"/>
      </el-form-item>


      <el-form-item label=" " prop="options.withPaypal">
        <el-checkbox v-model="item.options.withPaypal" id="withPaypal">Enable paypal</el-checkbox>
      </el-form-item>

      <el-form-item label="Paypal email" prop="options.paypalEmail" v-if="item.options.withPaypal">
        <el-input v-model="item.options.paypalEmail" id="paypalEmail"/>
      </el-form-item>

      <el-form-item label="Paypal Client ID" prop="options.paypalClientId" v-if="item.options.withPaypal">
        <el-input v-model="item.options.paypalClientId" id="paypalClientId"/>
      </el-form-item>

      <el-form-item label="Price" prop="options.paypalPrice" v-if="item.options.withPaypal" style="margin-bottom: 0;">
        <el-input v-model="item.options.paypalPrice" id="paypalPrice" type="number"/>
      </el-form-item>

      <el-form-item label="Enviroment" prop="options.paypalEnv" v-if="item.options.withPaypal">

        <el-select v-model="item.options.paypalEnv" id="paypalEnv" style="width: 100%">
          <el-option label="Sandbox" value="sandbox"/>
          <el-option label="Production" value="production"/>
        </el-select>

      </el-form-item>

      <div
        v-if="accountSettings && accountSettings.reservation && accountSettings.reservation.rooms && accountSettings.reservation.rooms.length">
        <el-form-item label=" " prop="options.withReservation" style="margin-bottom: 0;">
          <el-checkbox v-model="item.options.withReservation" id="withPaypal">Enable reservation</el-checkbox>
        </el-form-item>

        <el-form-item label="Room" prop="options.reservationRoom" v-if="item.options.withReservation">

          <el-select v-model="item.options.reservationRoom" id="paypalEnv" style="width: 100%">
            <el-option :label="room.title" :value="room._id" v-for="room in accountSettings.reservation.rooms"
                       :key="room._id"/>
          </el-select>

        </el-form-item>

        <el-form-item label="Party size caption" prop="options.partySizeCaption">

          <el-input v-model="item.options.partySizeCaption" id="partySizeCaption"/>

        </el-form-item>

        <el-form-item label="Reservation date caption" prop="options.reservationDateCaption">

          <el-input v-model="item.options.reservationDateCaption" id="reservationDateCaption"/>

        </el-form-item>

        <el-form-item label="Reservation time caption" prop="options.reservationTimeCaption">

          <el-input v-model="item.options.reservationTimeCaption" id="reservationTimeCaption"/>

        </el-form-item>

        <el-form-item label="Cancellation text" prop="options.cancellationText">

          <el-input v-model="item.options.cancellationText" id="cancellationText" type="textarea"/>

        </el-form-item>

        <el-form-item label="'No places' message" prop="options.noPlacesMessage">

          <el-input v-model="item.options.noPlacesMessage" id="noPlacesMessage" type="textarea"/>

        </el-form-item>

        <el-form-item label="Available party size" prop="options.availablePartySize">
          <el-checkbox-group v-model="item.options.availablePartySize">
            <el-checkbox label="1"></el-checkbox>
            <el-checkbox label="2"></el-checkbox>
            <el-checkbox label="3"></el-checkbox>
            <el-checkbox label="4"></el-checkbox>
            <el-checkbox label="5"></el-checkbox>
            <el-checkbox label="6"></el-checkbox>
            <el-checkbox label="7"></el-checkbox>
            <el-checkbox label="8"></el-checkbox>
            <el-checkbox label="9"></el-checkbox>
            <div>
              <el-checkbox label="10"></el-checkbox>
              <el-checkbox label="11"></el-checkbox>
              <el-checkbox label="12"></el-checkbox>
              <el-checkbox label="14"></el-checkbox>
              <el-checkbox label="16"></el-checkbox>
              <el-checkbox label="18"></el-checkbox>
              <el-checkbox label="20"></el-checkbox>
              <el-checkbox label="25"></el-checkbox>
            </div>
            <div>
              <el-checkbox label="30"></el-checkbox>
              <el-checkbox label="35"></el-checkbox>
              <el-checkbox label="40"></el-checkbox>
            </div>
          </el-checkbox-group>
        </el-form-item>
      </div>

      <el-form-item label="Permissions" prop="permissions">
        <el-select style="width: 100%" v-model="item.users" id="users" multiple remote filterable
                   :remote-method="loadUsers"
                   placeholder="Choose users"
                   :loading="loading" value-key="_id">
          <el-option
            v-for="item in users"
            :key="item._id"
            :label="item.username"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item size="large">
        <el-button type="primary" :loading="loading" @click="onSubmit">
          <span v-if="item._id">Save</span>
          <span v-else>Create</span>
        </el-button>
      </el-form-item>
    </el-form>


  </div>
</template>

<script>
  export default {
    props: [ 'item' ],
    computed: {
      accountSettings() {
        return this.$store.state.accountSettings;
      }
    },
    async mounted() {
      await this.$store.dispatch('getAccountSettings');
    },
    methods: {
      async onSubmit() {
        if (!await this.isValid()) {
          return this.$message.error('Fill field correctly!');
        }
        this.loading = true;
        try {
          let result;
          if (this.item._id) {
            result = await this.$axios.put(`/v1/forms/${this.item._id}`, this.item);
          } else {
            result = await this.$axios.post('/v1/forms', this.item);
            this.$router.push({ name: 'FormFieldsEdit', params: { id: result.data._id } })
          }
          this.$message.success('Saved!');
        } catch (err) {
          this.$message.error('Error!');
        }
        this.loading = false;
      },
      async isValid() {
        return new Promise((success) => {
          return this.$refs[ 'form' ].validate(valid => success(valid));
        });
      },
      async loadUsers(query) {
        this.loading = true;

        this.users = await this.$store.dispatch('getUsers', query);

        this.loading = false;
      }
    },
    data() {
      return {
        loading: false,

        icons: [
          'heart',
          'flag',
          'bookmark',
          'book',
          'diamond',
          'gift',
          'paypal',
          'money',
          'eur',
          'dollar'
        ],

        users: (this.item || {}).users || [],
        validation: {
          title: [ { required: true, trigger: "blur" } ],
          emails: [ { required: true, trigger: "blur" } ],

          'options.successMessage': [ { required: true, trigger: "blur" } ],
          'options.buttonCaption': [ { required: true, trigger: "blur" } ],
          'options.requiredFieldCaption': [ { required: true, trigger: "blur" } ]
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// SettingsDialog.vue?41c3fb1f